<template>
    <div class="registration_page">
        <div class="nav_header">
            <p class="nav_box">{{$t('index.youAreHere')}}：{{ navTitle }}</p>
            <p class="back_btn" @click="goback">
                <img
                    src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/返回.png"
                    alt=""
                />
                {{ $t("index.backPreviousPage") }}
            </p>
        </div>
        <!-- 内容 -->
        <h1 class="title_page">{{ $t("studentInfo.examType") }}</h1>
        <div class="exam_page">
            <!-- 头部 -->
            <div class="exam_header">
                <div class="subtitle">
                    <div
                        v-for="(item, index) in pageNav"
                        :key="index"
                        class="english_title"
                        :class="
                            activeIndex === item.index ? 'active_title' : ''
                        "
                        @click="getPageNav(item)"
                    >
                        {{currentLocale === "zh-CN" ? item.title : item.titleEn }}
                    </div>
                </div>
            </div>
            <div v-if="activeIndex === 0">
                <!-- 考试类型 -->
                <div
                    class="exam_type"
                    v-for="item in compositeList"
                    :key="item.id"
                >
                    <img
                        src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/logo/transparent.png"
                        alt=""
                    />
                    <div class="type_title">{{ currentLocale ==='zh-CN' ? item.title: item.titleEn }}</div>
                    <div class="type_desc">
                        <span
                            v-for="(desc, index) in getDescList(item)"
                            :key="index"
                            >{{ desc }}</span
                        >
                        <!-- <span class="age">适用于16岁及以上的学习者</span> -->
                    </div>
                    <span class="underline">
                        <i class="el-icon-document" style="font-size: 22px"></i>
                        {{
                            currentLocale === "zh-CN"
                                ? "线下机考"
                                : "In-Person Computer-Based"
                        }}
                    </span>
                </div>
            </div>
            <div v-if="activeIndex === 1">
                <!-- 自由组合 -->
                <div class="freedom_exam_selection">
                    <h2 class="title">{{ $t('selectAge.pleaseSelectexam') }}</h2>

                    <div class="selection_list">
                        <!-- 听力单项考试 -->
                        <div
                            v-for="item in normalList"
                            :key="item.id"
                            class="selection_item"
                            :class="{
                                'selection_item--active':
                                    getSelectedExams(item),
                            }"
                            @click="toggleSelection(item)"
                        >
                            <div class="item_header">
                                <div class="checkbox_wrapper">
                                    <div
                                        class="checkbox"
                                        :class="{
                                            'checkbox--checked':
                                                getSelectedExams(item),
                                        }"
                                    ></div>
                                </div>
                                <span class="item_title">{{ currentLocale ==='zh-CN' ? item.title: item.titleEn }}</span>
                            </div>
                            <p
                                class="item_description"
                                v-for="(desc, index) in getDescList(item)"
                                :key="index"
                            >
                                <span class="des">
                                    {{ desc }}
                                </span>
                            </p>

                            <!-- <p class="item_condition">
                               {{item.title}}
                            </p> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- 考期规则 -->
            <div class="exam_rules">
                <div class="rules_title">{{ $t("examDetail.rulesTitle") }}</div>
                <ul class="rules_list">
                    <li v-html="$t('examDetail.rulesContent')"></li>
                </ul>
            </div>
            <!-- <examSeatModal></examSeatModal> -->
            <!-- 选择考位 -->
            <div class="exam_selection">
                <div class="rules_title">
                    {{ $t("examDetail.chooseSeat") }}
                </div>
                <div class="selection_select">
                    <div class="selection_title">
                        <el-select
                            v-model="selectedPosition"
                            :placeholder="$t('examDetail.placeHolderOne')"
                            popper-class="custom-select-dropdown"
                            @change="onPositionChange"
                        >
                            <el-option
                                v-for="item in positionList"
                                :key="item.id"
                                :label="
                                    currentLocale === 'zh-CN'
                                        ? item.name
                                        : item.nameEn
                                "
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="selection_title">
                        <el-select
                            v-model="selectedYear"
                            :placeholder="$t('examDetail.placeHolderTwo')"
                            popper-class="custom-select-dropdown"
                            @change="onYearChange"
                        >
                            <el-option
                                v-for="item in yearList"
                                :key="item.id"
                                :label="
                                    currentLocale === 'zh-CN'
                                        ? item.name
                                        : item.nameEn
                                "
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <!-- 考位选项 -->
                <div class="slot_options">
                    <el-radio-group v-model="selecExamTime" size="big">
                        <el-radio
                            v-for="(slot, index) in filteredTimeList"
                            :key="index"
                            :label="slot.id"
                            size="medium"
                        >
                            <template #default>
                                <div class="slot_item">
                                    <div class="slot_time">
                                        <span class="label">
                                            {{
                                                currentLocale === "zh-CN"
                                                    ? "开考时间："
                                                    : "Exam opening time: "
                                            }}
                                        </span>
                                        <span class="value">{{
                                            bottomDate(slot)
                                        }}</span>
                                    </div>
                                    <div class="slot_seats">
                                        <img
                                            src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/个人中心.png"
                                            alt=""
                                        />
                                        <span class="label"
                                            >{{
                                                currentLocale === "zh-CN"
                                                    ? "剩余考位："
                                                    : "Remaining exam seats: "
                                            }}
                                        </span>
                                        <span class="value">
                                            {{ slot.minSeats }}</span
                                        >
                                    </div>
                                    <div class="slot_duration">
                                        <img
                                            src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/时长.png"
                                            alt=""
                                        />
                                        <span class="label"
                                            >{{
                                                $t("examDetail.duration")
                                            }}：</span
                                        >
                                        <span class="value">
                                            {{ slot.duration
                                            }}{{
                                                currentLocale === "zh-CN"
                                                    ? "分钟"
                                                    : "minute"
                                            }}
                                        </span>
                                    </div>
                                    <div class="slot_deadline">
                                        <img
                                            src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/时间.png"
                                            alt=""
                                        />
                                        <span class="label">{{
                                            currentLocale === "zh-CN"
                                                ? "报名截止时间："
                                                : "registration deadline: "
                                        }}</span>
                                        <span class="value">
                                            {{
                                                currentLocale === "zh-CN"
                                                    ? formatChineseNoYear(slot.deadlineTime)
                                                    : formatEnglish(slot.deadlineTime)
                                            }}
                                        </span>
                                    </div>
                                    <!-- <i class="el-icon-success"></i> -->
                                    <i
                                        class="el-icon-success"
                                        v-if="selecExamTime == slot.id"
                                    ></i>
                                    <i class="nocheck-radio" v-else></i>
                                    <p
                                        class="bottomdes"
                                        v-if="slot.isOverdue"
                                        style="color: red"
                                    >
                                        {{
                                            currentLocale === "zh-CN"
                                                ? `报名已结束，逾期报名将收取常规考试费用的20%作为逾期报名费`
                                                : "registration is closed. A 20% late fee applies"
                                        }}
                                    </p>
                                </div>
                            </template>
                        </el-radio>
                    </el-radio-group>
                    <div
                        class="nodata"
                        v-if="
                            filteredTimeList.length === 0 ||
                            (yearList.length === 0 && selectedPosition)
                        "
                    >
                        {{
                            currentLocale === "zh-CN"
                                ? `暂无可选考位`
                                : "There are currently no available exam slots available"
                        }}
                    </div>
                </div>

                <!-- 确认按钮 -->
                <button class="confirm_btn" @click="sureSubmit">
                    {{ $t("examDetail.confirm") }}
                </button>
            </div>
        </div>
        <Modal
            :showModal="showModal"
            :show-default-content="false"
            :show-default-tips="false"
            :show-cancel="false"
            show-size="small"
            @confirm="handleConfirm"
            @cancel="handleCancel"
        >
            <!-- 自定义内容插槽 -->
            <template #content>
                <div class="sure_checkout_content">
                    <el-result icon="success" size="large" class="result-image">
                        <template slot="extra">
                            <p class="p_text">
                                {{ $t("examDetail.successDate") }}
                                {{ successDate }}
                            </p>
                            <p class="p_text">
                                {{ $t("examDetail.successPosition") }}
                                {{ successPosition }}
                            </p>
                        </template>
                    </el-result>
                </div>
            </template>
            <!-- 自定义按钮插槽 -->
            <template #footer>
                <!-- <button class="btn-submit" @click="submitCustom">提交申请</button> -->
            </template>
        </Modal>
    </div>
</template>
<script>
import Vue from "vue";
import {
    getExamRescource,
    getreSourcePoint,
    getPositionRescource,
} from "@/plugins/api";
import { toCST, formatChinese, formatChineseNoYear, formatEnglish, formatEnglishFull, getYear, getMonth } from "@/utils/date";

export default Vue.extend({
    data() {
        return {
            navTitle: "报考类型",
            showModal: false,
            slots: [],
            pageNav: [
                {
                    title: "全项考试",
                    titleEn: "Full Exam",
                    index: 0,
                },
                {
                    title: "自由组合",
                    titleEn: "Free Combination",
                    index: 1,
                },
            ],
            options: [],
            activeIndex: 0,
            ageRadio: null,
            selectedExams: [], // 考试类型
            compositeList: [],
            normalList: [],
            currentLocale: "zh-CN",
            positionList: [],
            positionTimeList: [],
            selectedPosition: "", // 当前选中的考点
            yearList: [],
            selectedYear: "", // 当前选中的年份
            filteredTimeList: [], // 当前展示的考位时间
            isEditOrder: false,
            selecExamTime: null, // 选中考场
            successPosition: "",
            successDate: "",
            positionObj: {},
            formData: {}
        };
    },
    props: {},
    watch: {},
    mounted() {
        //   if (this.$store.state.auth.studentInfo) {
        //         const userInfo = this.$store.state.auth.studentInfo;
        //         this.selectedExams = userInfo.checkList;
        //         this.positionObj = userInfo.obj;
        //         this.selectedPosition = userInfo.examPositionId;
        //         this.selectedYear = userInfo.selectedYear;
        //         this.selecExamTime = userInfo.selecExamTime;
        //         this.activeIndex = userInfo.activeIndex;
        //         this.onPositionChange(this.selectedPosition);
        //     }
    },
    watch: {
        "$i18n.locale": {
            handler(newVal) {
                this.currentLocale = newVal || "zh-CN";
                this.navTitle = this.$route.meta && this.currentLocale === "zh-CN" ? this.$route.meta.title : this.$route.meta.titleEn;
            },
            immediate: true,
        },
    },
    computed: {},
    async created() {
        this.navTitle = this.$route.meta && this.currentLocale === "zh-CN" ? this.$route.meta.title : this.$route.meta.titleEn;
        // 返回上一页 数据回显
        await Promise.all([this.getExamList(), this.getPositionList()]);
        if (this.$store.state.auth.studentInfo) {
            const userInfo = this.$store.state.auth.studentInfo;
            this.formData = userInfo.formData;
            this.positionObj = userInfo.obj;
            this.selectedPosition = userInfo.examPositionId;
            this.activeIndex = userInfo.activeIndex;
            this.selectedYear = userInfo.selectedYear;
            this.onPositionChange(this.selectedPosition, 1);
            this.selecExamTime = userInfo.selecExamTime;
            await Promise.all([this.getPositionList()]);
        }
    },
    methods: {
        async getPositionList() {
            const res = await getreSourcePoint({channelCode: this.formData.channelCode});
            this.positionList = res;
        },
        async getExamList() {
            const res = await getExamRescource();
            this.compositeList = res.composite;
            this.normalList = res.normal;
            const userInfo = this.$store.state.auth.studentInfo;
            if (userInfo && userInfo.activeIndex !== 0) {
                if (userInfo.checkList.find((item) => item.id === 1)) {
                    this.selectedExams = JSON.parse(JSON.stringify(this.normalList));
                } else {
                    this.selectedExams = JSON.parse(JSON.stringify(userInfo.checkList))
                }
            } else {
                this.selectedExams = JSON.parse(JSON.stringify(this.compositeList[0]))
            }
            this.normalList.forEach((item) => {
                item.text =
                    this.currentLocale === "zh-CN" ? item.title : item.titleEn;
                item.value = item.id;
            });
        },
        getPageNav(item) {
            this.activeIndex = item.index;
            this.selectedExams = [];
            this.clearSelection();
        },
        getSelectedExams(item) {
            if (!this.selectedExams || this.selectedExams.length < 1) {
                return;
            }
            return this.selectedExams.find((item1) => item1.id === item.id);
        },
        // 选中数据清空
        clearSelection() {
            this.selectedYear = ""; // 选中年份
            this.selectedPosition = ""; // 选中地址
            this.filteredTimeList = []; // 过滤的考场信息
            this.selecExamTime = null; // 考试类型
        },
        toggleSelection(exam) {
            if (!exam) return;
            const index = this.selectedExams.findIndex(
                (item) => item.id === exam.id
            );
            if (index < 0) {
                this.selectedExams.push(exam);
            } else {
                this.selectedExams.splice(index, 1);
            }
            this.clearSelection();
        },
        bottomDate(slot) {
            if (!slot) return "";
            if (this.currentLocale === "zh-CN") {
                return `${formatChinese(slot.examTime)} ${slot.sessions}`;
            } else {
                return `${formatEnglishFull(slot.examTime)} ${slot.sessionsEn}`;
            }
        },
        getDescList(item) {
            if (!item) return [];
            const desc =
                this.currentLocale === "zh-CN" ? item.desc : item.descEn;
            return desc.split("\n").filter((item) => item.trim());
        },

        async onPositionChange(val, type) {
            this.selectedPosition = val;
            if (!val || val.length < 1) {
                // 清空年份数据以及日期
                this.selectedYear = "";
                this.selected = "";
                this.yearList = [];
                this.filteredTimeList = [];
            } else {
                await this.getPositionTimeList(val);
                this.generateYearList();
                if (!type) {
                    // 返回页面回显
                    this.selectedYear =
                        this.yearList.length > 0 ? this.yearList[0].id : "";
                }
                this.filterTimeList();
            }
        },
        async sureSubmit() {
            if (!this.selecExamTime) {
                this.$message.error(
                    this.currentLocale === "zh-CN"
                        ? "请选择考位时间"
                        : "Please select exam time"
                );
                return;
            }
            this.updateSuccessInfo();
            this.showModal = true;
        },
        handleConfirm() {
            this.showModal = false;
            const obj = this.filteredTimeList.find(
                (item) => item.id === this.selecExamTime
            );
            let list = [];
            let listObj = {};
            // 如果全选是【全选考试】参数
            if (
                this.selectedExams.length === this.normalList.length ||
                this.activeIndex === 0
            ) {
                list = [this.compositeList[0].id];
                listObj = [this.compositeList[0]];
            } else {
                list = this.selectedExams.map((item) => item.id);
                listObj = this.selectedExams;
            }
            this.$store.dispatch("auth/updateStudentPartial", {
                ageRadio: "A",
                examId: list,
                examPositionId: this.selectedPosition,
                checkList: listObj,
                positionObj: obj,
                activeIndex: this.activeIndex,
                selecExamTime: this.selecExamTime,
                selectedYear: this.selectedYear,
            });
            // this.$router.push({
            //     path: "/registration/Information",
            // });
            this.$router.push({ path: "/nopayOrder" });
        },
        handleCancel() {
            this.showModal = false;
        },
        updateSuccessInfo() {
            const dataobj = this.filteredTimeList.find(
                (item) => item.id === this.selecExamTime
            );
            if (this.currentLocale === "zh-CN") {
                this.successDate = formatChinese(dataobj.examTime) + dataobj.sessions;
            } else {
                this.successDate = formatEnglishFull(dataobj.examTime) + dataobj.sessionsEn;
            }
            const obj = this.positionList.find(
                (item) => item.id === this.selectedPosition
            );
            this.successPosition = obj.name;
        },
        // 获取考位时间信息
        async getPositionTimeList(position) {
            let list = [];
            if (
                this.activeIndex === 0 ||
                this.selectedExams.length === this.normalList.length
            ) {
                list = [this.compositeList[0].id];
            } else {
                list = this.selectedExams.map((item) => item.id);
            }
            let obj = {
                examPointId: position,
                examPositionId: null,
                examIds: list,
                channelCode: this.formData.channelCode || null
                // isUpdate: this.isEditOrder ? 1 : 0 //编辑1新建0
            };
            const res = await getPositionRescource(obj);
            this.positionTimeList = res;
        },
        generateYearList() {
            const years = Array.from(
                new Set(
                    this.positionTimeList.map((item) => {
                        return getYear(item.examTime);
                    })
                )
            );
            years.sort((a, b) => a - b);
            this.yearList = years.map((y) => ({
                id: y,
                name: `${y}年`,
                nameEn: `${y}`
            }));
        },
        onYearChange(val) {
            this.selectedYear = val;
            if (!val) {
                this.filteredTimeList = [];
                this.selected = "";
            } else {
                this.filterTimeList();
            }
        },
        filterTimeList() {
            this.filteredTimeList = this.positionTimeList.filter((item) => {
                return getYear(item.examTime) == this.selectedYear;
            });
            this.filteredTimeList.sort((a, b) => {
                return getMonth(a.examTime) - getMonth(b.examTime);
            });
        },

        goback() {
            this.$router.go(-1);
        },
    },
});
</script>
<style lang="stylus" scoped>
.registration_page {
    min-height: calc(100vh - 620px);
    margin-bottom: 200px;

    .nav_header {
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: space-between;

        .nav_box {
            padding: 20px 0;
            font-size: 15px;
            color: #333;
        }

        .back_btn {
            display: flex;
            flex-flow: row;
            align-items: center;
            font-size: 15px;

            img {
                width: 20px;
                margin-right: 10px;
            }
        }
    }

    .title_page {
        width: 100%;
        text-align: center;
        margin-bottom: 90px;
    }

    .exam_page {
        font-family: 'Microsoft YaHei', sans-serif;
        color: #333;
        max-width: 1200px;
        margin: 0 auto;
        padding: 20px;
        background: #fff;
        position: relative;
        z-index: 2;
    }

    // 头部样式
    .exam_header {
        text-align: center;
        margin-bottom: 30px;
        width: 800px;
        margin: 0 auto;
        position: absolute;
        top: -52px;
        left: 50%;
        z-index: 1;
        margin-left: -400px;

        .title {
            font-size: 48px;
            font-weight: bold;
            margin-bottom: 10px;
            color: #000;
        }

        .subtitle {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .english_title {
                display: flex;
                flex-flow: row;
                align-items: center;
                justify-content: center;
                width: 400px;
                height: 52px;
                background: linear-gradient(0deg, #E9E9E9 0%, #FFFFFF 100%);
                border-radius: 6px 6px 0px 0px;
                border: 1px solid #DDDDDD;
                text-align: center;
                font-size: 20px;
                color: #0043E0;
                margin-left: 32px;
            }

            .active_title {
                background: #fff;
                border-bottom: none;
            }
        }
    }

    // 考试类型
    .exam_type {
        margin-bottom: 30px;
        background-image: url('https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/全项组合.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        min-height: 160px;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        color: #fff;
        position: relative;

        .type_title {
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 10px;
            position: relative;
        }

        .type_title::after {
            content: '';
            position: absolute;
            bottom: -10px;
            left: 50%;
            margin-left: -20px;
            width: 40px;
            height: 4px;
            background: #fff;
            z-index: 1;
        }

        .type_desc {
            display: flex;
            flex-direction: column;
            font-size: 16px;
            text-align: center;
            margin-top: 18px;
        }

        .underline {
            position: absolute;
            top: 10px;
            right: 20px;
            font-size: 18px;
            color: #fff;
            z-index: 1;
            display: flex;
            align-items: center;
        }

        > img {
            position: absolute;
            width: 158px;
            top: 10px;
            left: 10px;
            z-index: 2;
        }
    }

    .rules_title {
        font-weight: bold;
        margin-bottom: 15px;
        font-size: 22px;
        color: #011E41;
    }

    // 考期规则
    .exam_rules {
        margin-bottom: 30px;

        .rules_list {
            list-style-type: none;
            padding-left: 0;

            li {
                font-size: 18px;
                position: relative;
                font-size: 18px;
                color: #011E41;
                line-height: 32px;
                // &::before {
                // content: '•';
                // position: absolute;
                // left: 0;
                // color: #000;
                // font-size: 24px;
                // }
            }

            li:last-child {
                padding-bottom: 20px;
                border-bottom: 1px solid #ddd;
            }
        }
    }

    // 选择考位
    .exam_selection {
        .selection_select {
            display: flex;
            flex-flow: row;
            align-items: center;
            justify-content: space-between;

            // gap: 20px;
            .selection_title {
                width: 49%;
                margin-bottom: 20px;

                .el-select {
                    width: 100%;
                }

                >>>.el-input__inner {
                    // height: 58px !important;
                    // line-height: 58px !important;
                    // background-color: #FAFCFF;
                    // border-radius: 10px;
                    // border: 1px solid #78A0D0;
                }
            }
        }

        .slot_options {
            // display: flex;
            // flex-direction: row;
            // flex-wrap: wrap;
            margin-bottom: 40px;

            ::v-deep .el-radio__inner {
                display: none;
            }

            .el-radio-group {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 1vw !important;
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(49%, 1fr));
            }

            .el-radio {
                width: 100%;
                margin-right: 0;
                box-sizing: border-box;
            }

            .slot_item {
                width: 100%;
                border: 1px solid #ddd;
                border-radius: 10px;
                padding: 20px;
                background: linear-gradient(0deg, #F0F7FF 0%, #FAFCFF 50%, #FAFCFF 100%);
                position: relative;

                // border: 1px solid #78A0D0;
                .slot_time {
                    display: flex;
                    align-items: center;
                    margin-bottom: 12px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    .label, .value {
                        font-size: 22px;
                        color: #011E41;
                        font-weight: 600;
                    }
                }

                .slot_seats, .slot_duration, .slot_deadline {
                    display: flex;
                    align-items: center;

                    img {
                        width: 18px;
                        margin-right: 8px;
                    }

                    .label, .value {
                        font-size: 18px;
                        color: #011E41;
                        line-height: 33px;
                    }
                }

                .bottomdes {
                    font-size: 13px;
                }

                > i {
                    position: absolute;
                    right: 20px;
                    top: 50%;
                    z-index: 1;
                    margin-top: -20px;
                }
            }

            .nodata {
                font-size: 18px;
                text-align: center;
                height: 100px;
                line-height: 100px;
                border-radius: 10px;
                border: 1px solid #78a0d0;
            }
        }

        .confirm_btn {
            display: block;
            margin: 0 auto;
            color: #fff;
            font-size: 28px;
            font-weight: bold;
            border: none;
            cursor: pointer;
            text-align: center;
            width: 280px;
            height: 74px;
            background: #0043E0;
            border-radius: 37px;

            &:hover {
                background-color: #0043E8;
                color: #f5f5f5;
            }
        }
    }

    // 自由组合
    .freedom_exam_selection {
        font-family: 'Microsoft YaHei', 'Arial', sans-serif;
        width: 100%;
        margin: 0 auto 28px 0;
        padding: 22px;
        background: #CAD7D8;

        .title {
            font-size: 24px;
            font-weight: 600;
            color: #333;
            margin-bottom: 10px;
            text-align: center;
            padding-bottom: 15px;
        }

        .selection_list {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(520px, 1fr));
            gap: 20px;

            @media (max-width: 640px) {
                grid-template-columns: 1fr;
            }

            // }
            .selection_item {
                // width: 50%;
                background-color: #fff;
                // border: 2px solid #e0e0e0;
                border-radius: 10px;
                padding: 26px 24px;
                cursor: pointer;
                transition: all 0.3s ease;
                position: relative;

                &:hover {
                    border-color: #409eff;
                    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.1);
                }

                &--active {
                    border-color: #409eff;
                    background-color: #f0f9ff;
                }
            }

            .item_header {
                display: flex;
                align-items: center;
                margin-bottom: 18px;
                position: relative;
                padding-bottom: 20px;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    background-color: #e0e0e0;
                    z-index: 1;
                    height: 4px;
                    background: linear-gradient(90deg, #E2CB24 0%, #50B9AA 100%);
                }

                .checkbox_wrapper {
                    margin-right: 12px;
                    flex-shrink: 0;
                    position: absolute;
                    top: 0px;
                    right: 0;
                    font-size: 20px;
                    z-index: 2;

                    .checkbox {
                        width: 36px;
                        height: 36px;
                        border: 2px solid #c0c4cc;
                        border-radius: 4px;
                        position: relative;
                        transition: all 0.3s ease;

                        &--checked {
                            background-color: #409eff;
                            border-color: #409eff;

                            &::after {
                                content: '';
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                margin-top: -14px;
                                margin-left: -5px;
                                width: 10px;
                                height: 20px;
                                border: solid white;
                                border-width: 0 2px 2px 0;
                                transform: rotate(45deg);
                            }
                        }
                    }
                }

                .item_title {
                    font-weight: bold;
                    font-size: 22px;
                    color: #011E41;
                    line-height: 33px;
                }
            }

            .item_description, .item_condition {
                font-weight: 400;
                font-size: 18px;
                color: #011E41;
                line-height: 30px;
                display: flex;
                flex-flow: row;
                align-items: center;
            }

            .item_description::before, .item_condition::before {
                content: '';
                display: inline-block;
                width: 6px;
                height: 6px;
                background: #0043E0;
                border-radius: 50%;
                background-color: #c0c4cc;
                vertical-align: middle;
                margin-right: 8px;
            }
        }
    }
}

.sure_checkout_content .p_text {
    font-weight: 400;
    font-size: 17px;
    color: #011E41;
    line-height: 30px;
    text-align: left;
}

@media (max-width: 640px) {
    .registration_page {
        min-height: calc(100vh - 20vw);
        margin-bottom: 20vw;

        .nav_header {
            .nav_box {
                // padding: 20px 0;
                font-size: 3.2vw;
                color: #333;
            }

            .back_btn {
                font-size: 3.2vw;

                img {
                    width: 4vw;
                    // margin-right: 10px;
                }
            }
        }

        .title_page {
            margin-bottom: 14vw;
        }

        .exam_header {
            // text-align: center;
            // margin-bottom: 30px;
            width: 90vw;
            margin: 0 auto;
            position: absolute;
            top: -5vh;
            left: 50%;
            z-index: 1;
            margin-left: -45vw;

            .title {
                font-size: 48px;
                font-weight: bold;
                margin-bottom: 10px;
                color: #000;
            }

            .subtitle {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 2vw;

                .english_title {
                    width: 40vw;
                    height: 5vh;
                    margin-left: 0;
                    font-size: 3.8vw;
                }
            }
        }

        .rules_title {
            font-size: 3.8vw;
            display: none;
        }

        .exam_type {
            background-image: url('https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/全项组合移动.png');
            min-height: 28vw;
            margin-bottom: 6vw;

            .type_title {
                font-size: 4.8vw;
            }

            .type_desc, .underline {
                font-size: 3vw;
            }

            > img {
                width: 22vw;
                top: 10px;
                left: 10px;
            }
        }

        .exam_rules {
            margin-bottom: 3vw;

            .rules_list {
                li {
                    font-size: 3vw;
                    line-height: 4.2vw;
                    margin-bottom: 2vw;
                }

                li:last-child {
                    padding-bottom: 3vw;
                }
            }
        }

        .exam_selection {
            .selection_select {
                display: grid;
                gap: 0;
                grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));

                .selection_title {
                    width: 100%;
                    margin-bottom: 3vw;

                    >>>.el-input__inner {
                        // height: 10vw !important;
                        // line-height: 10vw !important;
                        // background-color: #FAFCFF;
                        // border-radius: 10px;
                        // border: 1px solid #78A0D0;
                    }
                }
            }

            .slot_options {
                .el-radio {
                    width: 100%;
                }

                .el-radio-group {
                    grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
                }

                .slot_item {
                    .slot_time {
                        .label, .value {
                            font-size: 3.6vw;
                        }
                    }

                    .slot_seats, .slot_duration, .slot_deadline {
                        img {
                            width: 3.8vw;
                        }

                        .label, .value {
                            font-size: 3vw;
                            line-height: 5vw;
                        }
                    }

                    .bottomdes {
                        font-size: 2.6vw;
                    }
                }

                .nodata {
                    font-size: 3vw;
                    height: 16vw;
                    line-height: 16vw;
                    border-radius: 2vw;
                }
            }

            .confirm_btn {
                width: 100%;
                height: 12vw;
                font-size: 4.2vw;
            }
        }

        .freedom_exam_selection {
            padding: 2vw 2vw;

            .title {
                font-size: 4.8vw;
                margin-bottom: 2vw;
            }

            .selection_list {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
                gap: 6vw;

                @media (max-width: 640px) {
                    grid-template-columns: 1fr;
                }

                .selection_item {
                    border-radius: 10px;
                    padding: 4vw 3.8vw;
                }

                .item_header {
                    margin-bottom: 3vw;
                    padding-bottom: 2vw;

                    &::after {
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        z-index: 1;
                        height: 4px;
                    }

                    .checkbox_wrapper .checkbox {
                        width: 6vw;
                        height: 6vw;

                        &--checked {
                            &::after {
                                top: 50%;
                                left: 50%;
                                margin-top: -2.8vw;
                                margin-left: -1vw;
                                width: 2vw;
                                height: 4vw;
                            }
                        }
                    }

                    .item_title {
                        font-size: 3.8vw;
                        line-height: 33px;
                    }
                }

                .item_description, .item_condition {
                    font-size: 3.4vw;
                    line-height: 5vw;
                }

                .item_description::before, .item_condition::before {
                    width: 1.2vw;
                    height: 1.2vw;
                    margin-right: 1vw;
                }
            }
        }
    }
}
</style>